import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/sections/Navbar";
import Hero from "@/sections/Hero";
import Services from "@/sections/Services";
import About from "@/sections/About";
import QuoteForm from "@/sections/QuoteForm";
import Contact from "@/sections/Contact";
import Footer from "@/sections/Footer";

const Landing = () => (
  <div className="App">
    <Navbar />
    <main>
      <Hero />
      <Services />
      <About />
      <QuoteForm />
      <Contact />
    </main>
    <Footer />
    <Toaster
      theme="dark"
      position="bottom-right"
      toastOptions={{
        style: {
          background: "#0c0c0c",
          color: "#ffffff",
          border: "1px solid rgba(255,255,255,0.14)",
        },
      }}
    />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="*" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
